module.exports = __webpack_public_path__ + "media/images/administrator-icon-47cb4f31b53b94ba6e3ab36685638292.svg";